import Vue from "vue";

import { NativeApp } from "./";
import Android, { isAndroid } from "./android";
import IOS, { isIOS } from "./ios";
import Noop from "./noop";

export default function install(vue: typeof Vue) {
  // Determine the native app being used, if it isn't iOS or Android, default to a no-op
  let nativeApp: NativeApp;
  if (isIOS()) {
    nativeApp = new IOS();
  } else if (isAndroid()) {
    nativeApp = new Android();
  } else {
    nativeApp = new Noop();
  }

  // Register the native app so that it can communicate with Vue.js
  nativeApp.register();

  // Make the native app available to Vue
  vue.prototype.$nativeApp = nativeApp;
}
